import React from "react";

import { cn } from "@/utils/general";

import styles from "./InputError.module.scss";

/**
 * Props for the InputErrorWild component.
 */
interface InputErrorProps {
  message: string;
  className?: string;
}

/**
 * InputErrorWild component displays a formatted error message for input fields.
 * It uses SCSS Modules for styling.
 */
export const InputError: React.FC<InputErrorProps> = ({ message, className }) => {
  return <p className={cn(styles.errorText, className)}>{message}</p>;
};
